import {
  REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG,
  REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG_ERROR,
  RECEIVE_INTEGRATIONS_BY_WORKSPACE_SLUG,
  UPDATED_INTEGRATION
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG,
  failure: REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG_ERROR,
  receive: RECEIVE_INTEGRATIONS_BY_WORKSPACE_SLUG
})

export default function (state = {}, { type, payload = {} }) {
  switch (type) {
    case REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG:
    case REQUEST_INTEGRATIONS_BY_WORKSPACE_SLUG_ERROR:
    case RECEIVE_INTEGRATIONS_BY_WORKSPACE_SLUG:
      const { workspaceSlug } = payload
      return {
        ...state,
        [workspaceSlug]: reducer(state[workspaceSlug], { type, payload })
      }
    case UPDATED_INTEGRATION:
      return updatedIntegration(state, payload)
    default:
      return state
  }
}

function updatedIntegration (state, payload) {
  const { workspaceSlug, response } = payload
  const workspace = state[workspaceSlug] || {}
  const integrations = workspace.data ? [...workspace.data] : []
  const index = integrations.findIndex(i => i.id === response.id)

  if (index === -1) {
    integrations.push(response)
  } else {
    integrations[index] = response
  }

  return {
    ...state,
    [workspaceSlug]: {
      ...state[workspaceSlug],
      data: integrations
    }
  }
}



// WEBPACK FOOTER //
// ./reducers/integrations.js